import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

import { isProductionEnvironment } from "utils/env";

import { TableSelectionState } from "./types";
import makeTableSelectionSlice from "./makeTableSelectionSlice";

const createTableSelectionStore = () =>
  create<TableSelectionState>()(
    devtools(
      immer((...a) => ({
        ...makeTableSelectionSlice()(...a),
      })),
      { enabled: !isProductionEnvironment() }
    )
  );

export default createTableSelectionStore;
